<template>
  <v-card @click="goToPage"
    color="primary"
    flat
    tile
    :max-width="!$vuetify.breakpoint.mdAndDown ? '100%': '100%'"
    :width="!$vuetify.breakpoint.mdAndDown ? '100%': '100%'"
  >
    <v-img height="250" :src="isPending ? home.homevestpackage.housepackage.image : home.package.image"></v-img>

    <div class="py-4 px-10 text-justify">
      <div class="text-h6 font-weight-bold white--text mt-3" v-if="home">{{ isPending ? home.homevestpackage.housepackage.packagename : home.package.packagename }}</div>
      <div class="d-flex justify-space-between align-center">
        <v-card flat color="secondary" class="px-2 rounded-pill d-flex">
          <div class="text-caption font-weight-medium white--text" v-if="home.location || home.homevestpackage.location">{{ isPending? home.homevestpackage.location.name :home.location.name }}</div>
        </v-card>
        <div class="d-flex align-center">
          <hm-icon height="13">
            <homes-icon />
          </hm-icon>
          <span class="secondary--text text-caption">{{  home.slots }} Unit(s)</span>
        </div>
      </div>
      <v-card height="8px" class="rounded-pill mt-9" flat width="100%" color="white" v-if="!isPending">
        <v-card height="8px" flat :width="`${(home.totalpaid / home.total) * 100}%`" color="secondary" class="rounded-pill"></v-card>
      </v-card>
      <div class="d-flex justify-space-between mt-2" v-if="!isPending">
        <div>
          <div class="white--text text-h7 font-weight-medium">Amount Paid</div>
          <div class="success--text text-caption">{{formatMoney(home.totalpaid)}}</div>
        </div>

        <div class="text-right">
          <div class="white--text text-h7 font-weight-medium">Total Amount</div>
          <div class="secondary--text text-caption">{{formatMoney(home.total)}}</div>
        </div>
      </div>
      <div class="d-flex justify-space-between mt-2" v-else>
        <div>
          <div class="white--text text-h7 font-weight-medium">Purchase Date</div>
          <div class="success--text text-caption">{{formatDate(home.createdat)}}</div>
        </div>
      </div>
    </div>
  </v-card>
</template>

<script>
import HomesIcon from "@/components/icons/homes/HomesIcon.vue";
import HmIcon from "@/components/HmIcon.vue";
import { formatMoney, formatDate } from "@/utils/helpers";

export default {
  components: {
    HmIcon,
    HomesIcon,
  },
  props: {
    home: {
      type: Object
    },
    isPending: {
      type: Boolean,
      default: false,
    }
  },
  data(){
    return {
      formatMoney,
      formatDate
    }
  },
  methods: {
    goToPage(){
      this.$router.push({name: "dashboard.homes.details", params: { id: this.home.id }})
    }
  }
};
</script>
